module.exports = __webpack_public_path__ + "img/Just Shoplogo.443fcb47.svg";